export enum GroupLocation {
    IN_HOUSE = "In-house",
    ONLINE = "Online"
}
